import React from "react";
import ReactGA from 'react-ga';
import Link from "react-router-dom/Link";
import Page from "../Page";
import restartSVG from "img/restart.svg";

import arrival from "img/arrival.png";

export default function Arrival({ resetData }) {
  ReactGA.pageview('/arrival')
  return (
    <Page>
      <div className="arrival-page">
        <div className="introduction-page__restart-block">
          <ul className="arrival-page__arms-list">
            <li>A</li>
            <li>R</li>
            <li>M</li>
            <li>S</li>
          </ul>
          <Link
            to={{ pathname: "/login", state: { prev: true } }}
            className="introduction-page__restart-btn"
            href="#"
            onClick={resetData}
          >
            <img
              className="introduction-page__restart-icon"
              src={restartSVG}
              alt=""
            />
            <span>Restart</span>
          </Link>
        </div>
        <div className="arrival-page__main-section">
          <img className="arrival-page__image" src={arrival} alt="" />
          <div className="arrival-page__find-product-block">
            <h1 className="arrival-page__header-text">Customer Arrives</h1>
            <p>
              This customer wants to purchase a Nest Camera for their home. Help
              the customer complete their purchase.
            </p>
            <Link
              to={{
                pathname: "/problem/1",
                state: { prev: true }
              }}
              className="btn login-page__start-btn"
            >
              <span>Find product</span>
            </Link>
          </div>
        </div>
      </div>
    </Page>
  );
}
